import { useQuery } from '@tanstack/react-query';
import portalApi from 'utils/portalApi';

const getProject = async (projectId) => {
    const { data } = await portalApi.get(`api/projects/${projectId}`);
    return data;
};

const useProject = (projectId) => {
    const { data, refetch, isLoading, isError, error } = useQuery({
        queryKey: ['project', projectId],
        queryFn: () => getProject(projectId)
    });

    return { data, refetch, isLoading, isError, error };
};

export default useProject;
